import styled, { css } from 'styled-components'
import { ButtonUnstyled, MenuLink } from '@sketch/components'
import { ReactComponent as ChevronRightIcon } from '@sketch/icons/chevron-right-17'

import { ReactComponent as PushPinIcon } from '@sketch/icons/img-pushpin-9'
import { ReactComponent as PushPinShadowIcon } from '@sketch/icons/img-pushpin-shadow-9'
import { overlayColors } from '@sketch/utils'

const pushPinPosition = css`
  width: 9px;
  position: absolute;
  bottom: -3px;
  right: -1px;

  rotate: 45deg;
`

export const PushPinShadow = styled(PushPinShadowIcon)`
  ${pushPinPosition}

  /* Correct for the shadow positioning */
  bottom: -4px;
  color: ${({ theme }) => theme.colors.background.secondary.A};

  /* When the link is active we need to correct the colors of the shadow */
  .active && {
    color: ${({ theme }) =>
      theme._name === 'dark'
        ? theme.colors.sketch.A
        : overlayColors(
            theme.colors.background.secondary.A,
            theme.colors.sketch.F
          )};
  }

  /* When the link is hovered we need to correct the colors of the shadow */
  a:hover & {
    color: ${({ theme }) =>
      overlayColors(
        theme.colors.background.secondary.A,
        theme.colors.background.tertiary.C
      )};
  }
`

export const PushPin = styled(PushPinIcon)`
  ${pushPinPosition}
`

export const IconWithPinWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;
`

export const CollapsibleButton = styled(ButtonUnstyled).attrs({
  'data-testid': 'collapsible-trigger',
})`
  display: flex;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  margin-left: -4px;
  border-radius: ${({ theme }) => theme.radii.small};

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.tertiary.C};
  }

  .active &:hover {
    background-color: ${({ theme }) => theme.colors.sketch.F};
  }

  & > svg,
  & > ${IconWithPinWrapper} {
    margin-right: 0;
  }
`

export const ChevronRight = styled(ChevronRightIcon)``

export const ChevronDown = styled(ChevronRightIcon)`
  transform: rotate(90deg);
`

export const NestedProjectsWrapper = styled.div<{ level: number }>(
  ({ level }) => css`
    ${MenuLink} {
      /* 8px padding per level + 12px existing padding */
      padding-left: calc(${level} * 8px + 12px);
    }
  `
)

export const TouchOnlyCollapsibleWrapper = styled(ButtonUnstyled)<{
  disabled?: boolean
}>`
  display: none;
  width: 40px;
  height: 32px;

  flex-shrink: 0;

  @media (hover: none) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      opacity: 0;
    `}
`

export const TouchOnlyCollapsibleIcon = styled(ChevronRight)<{
  $open?: boolean
}>`
  width: 17px;
  height: 17px;

  transition: transform 0.3s ease-in-out;

  ${({ $open }) =>
    $open &&
    css`
      transform: rotate(90deg);
    `}
`
